import { useEffect, useRef } from "react";
import staticTemplate from "./static-template.html?raw";
import "./static.css";

export default function Home() {
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    const menuToggle = root.querySelector<HTMLButtonElement>(".menu-toggle");
    const mobileNav = root.querySelector<HTMLElement>(".mobile-nav");
    const mobileLinks = [...root.querySelectorAll<HTMLAnchorElement>(".mobile-nav a")];
    const faqButtons = [...root.querySelectorAll<HTMLButtonElement>(".faq-question")];
    const revealElements = [...root.querySelectorAll<HTMLElement>(".reveal")];

    const setMenuOpen = (open: boolean) => {
      mobileNav?.classList.toggle("is-open", open);
      menuToggle?.setAttribute("aria-expanded", String(open));
      menuToggle?.setAttribute("aria-label", open ? "Đóng menu" : "Mở menu");
    };

    const toggleMenu = () => {
      setMenuOpen(!mobileNav?.classList.contains("is-open"));
    };

    const closeMenu = () => setMenuOpen(false);

    const toggleFaq = (event: Event) => {
      const button = event.currentTarget as HTMLButtonElement;
      const item = button.closest<HTMLElement>(".faq-item");
      if (!item) return;

      const wasOpen = item.classList.contains("is-open");
      root.querySelectorAll<HTMLElement>(".faq-item.is-open").forEach((openItem) => {
        openItem.classList.remove("is-open");
        openItem.querySelector(".faq-question")?.setAttribute("aria-expanded", "false");
      });

      if (!wasOpen) {
        item.classList.add("is-open");
        button.setAttribute("aria-expanded", "true");
      }
    };

    const handleResize = () => {
      if (window.innerWidth > 920 && mobileNav?.classList.contains("is-open")) {
        closeMenu();
      }
    };

    menuToggle?.addEventListener("click", toggleMenu);
    mobileLinks.forEach((link) => link.addEventListener("click", closeMenu));
    faqButtons.forEach((button) => button.addEventListener("click", toggleFaq));
    window.addEventListener("resize", handleResize);

    revealElements.forEach((element, index) => {
      element.style.transitionDelay = `${Math.min(index % 3, 2) * 70}ms`;
    });

    const observer =
      "IntersectionObserver" in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  entry.target.classList.add("is-visible");
                  observer.unobserve(entry.target);
                }
              });
            },
            { rootMargin: "0px 0px -8% 0px", threshold: 0.08 },
          )
        : null;

    if (observer) {
      revealElements.forEach((element) => observer.observe(element));
    } else {
      revealElements.forEach((element) => element.classList.add("is-visible"));
    }

    return () => {
      menuToggle?.removeEventListener("click", toggleMenu);
      mobileLinks.forEach((link) => link.removeEventListener("click", closeMenu));
      faqButtons.forEach((button) => button.removeEventListener("click", toggleFaq));
      window.removeEventListener("resize", handleResize);
      observer?.disconnect();
    };
  }, []);

  return (
    <div
      ref={rootRef}
      className="vay3phut-site"
      dangerouslySetInnerHTML={{ __html: staticTemplate }}
    />
  );
}
